import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'userblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent {

  constructor(public router: Router, private api: ApiService) {
  }

  username() {

    let data = this.api.user;

    return data != null ? data.Username : "";
  }

  picture() {
    
    return "assets/img/user/default.jpg";
  }
}
